import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DockStateService {
  readonly side$ = new BehaviorSubject<'left' | 'right'>('left');

  setSide(side: 'left' | 'right'): void {
    this.side$.next(side);
  }
}
